import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { saveLoanApplicantDetails } from "store/reducers/LoanDetail/LoanDetailSlice";
import { saveLoanDetails } from "store/reducers/LoanDetail/LoanDetailSlice";
import { textFormat } from "utils/Utils";
import { FormControl, Grid, InputLabel } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "components/UpdateUi/CustomeSelect";
import brandTheme from "brandTheme/Theme";
import { useNavigate, useOutletContext } from "react-router-dom";
import { saveAadharDetails } from "store/reducers/LoanApplication/LoanApplicationSlice";
import { saveAadharTransaction } from "store/reducers/LoanApplication/LoanApplicationSlice";
import ToastModal from "views/components/ToastModal";
import { APPLICATION_SUB_TYPE_POST_PLEDGE } from "assets/properties/properties";
import { APPLICATION_TYPE_BT } from "assets/properties/properties";
import { APPLICATION_TYPE_RE_PLEDGE } from "assets/properties/properties";
import { CHECK_LOAN_MARKINGS } from "assets/properties/properties";
import { getDateOnly } from "utils/Utils";
import OtpModal from "views/admin/pages/FieldAgent/OtpModal/OtpModal";
import { repledgeCaseListName } from "assets/properties/properties";
import { loanApplicationStatusNamesList } from "assets/properties/properties";
import { APPLICATION_TYPE_New } from "assets/properties/properties";
import { LOAN_STATUS_CLOSED } from "assets/properties/properties";
import { collateralOperationStatus } from "assets/properties/properties";
import { saveSelfieDetails } from "store/reducers/LoanApplication/LoanApplicationSlice";
import { getPreviousDateFromTheMaturityAccToDays } from "utils/Utils";
import { checkForRepledgeAccount } from "utils/Utils";
import { denialReasonsList } from "assets/properties/properties";
import { getDenialMessage } from "utils/denialMessageUtils";
import checkNegativeProfileApi from "views/admin/pages/FieldAgent/Applicant/CheckNegativeProfileApi";
import ConfirmationModal from "../../ConfirmationModal";
import MSelect from "react-select";
import makeAnimated from "react-select/animated";
import { removeUnderscoresAndCapitalize } from "utils/Utils";
import { sanitizeLoanAccountNumber } from "utils/Utils";
import { maskMobileNumber } from "utils/Utils";

const style = () => ({
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  fieldContaienr:{
    margin: "2% 2% 0px 2%",
    maxWidth: "29.3%",
    "@media (max-width: 768px)": {
      maxWidth:'46%',
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth:'100%',
    },
    "@media (max-width: 450px)": {
      margin:"10% 2% 0px 2%"
    },
  },
  header: {
    fontSize: brandTheme.headerFontSize,
    fontWeight: 700,
    lineHeight: "1.5rem",
    fontFamily: brandTheme.font.poppins,
    margin: "2% 2% 0px 2%",
  },
  inputContainer:{
  },
  label:{
    fontSize: "1.2rem",
    marginLeft: ".3rem",
	marginTop: "1.1rem",
	color: brandTheme.labelColor,
  "&:focus,&:visited,&": {
    position: "absolute",
	fontSize: ".7rem",
	marginTop:" -0.6rem",
	color: brandTheme.black,
  },
  },
  nextButton:{
    boxShadow:'inherit',
    color:brandTheme.white,
    margin:"10px 10px 10px 0 ",
    letterSpacing:"1px",
    height:"40px",
    // width:"8%",
    padding:'0px 40px',
    backgroundColor:brandTheme.buttonColor,
    width:"100px",
    '&:hover':{
      backgroundColor:brandTheme.buttonHoverColor, 
      boxShadow:'inherit',
    },
    '&:focus':{
      backgroundColor:brandTheme.buttonHoverColor, 
      boxShadow:'inherit',
    }
  },
  nextButton1:{
    boxShadow:'inherit',
    color:brandTheme.white,
    margin:"10px 10px 10px 0 ",
    padding:'0px 40px',
    height:"40px",
    width:"100px",
    // width:"8%",
    backgroundColor:brandTheme.button2Color,
    '&:hover':{
      backgroundColor:brandTheme.buttonHoverColor, 
      boxShadow:'inherit',
    },
    '&:focus':{
      backgroundColor:brandTheme.buttonHoverColor, 
      boxShadow:'inherit',
    }
  }
})
const useStyles = makeStyles(style);
const InProcessCreateApplication = ({ closeModal, GetData, seletedBranchCode }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [name, setName] = useState("");
  const [nameState, setNameState] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileNumberState, setMobileNumberState] = useState(false);
  const [email,setEmail]=useState("");
  const [loanAmount, setLoanAmount] = useState("");
  const [appointmentDate, setappointmentDate] = useState("");
  const [loanApplicationId, setLoanApplicationId] = useState("");
  const [isErrorMode, setErrorMode] = useState(false);
  const [isOtpMode, setIsOtpMode] = useState(false);
  const [otpValidation, setOtpValidation] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const { userDetails } = useSelector((state) => state.userDetail.userDetails);
  const [reLoanAccoutnNumber,setReLoanAccountNumber]=useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const [loanAmountList]=useState([{code:"OneLakh",name:"Less than 1 Lakh"},{code:"OneToFiveLahk",name:"Between 1 - 5 Lakhs"},{code:"FiveLakh",name:"Above 5 Lakhs"}])
  const [applicationType,setApplicationType]=useState(APPLICATION_TYPE_New);
  const [applicationTypeState,setApplicationTypeState]=useState(false);
  const [applicationSubType,setApplicationSubType]=useState(APPLICATION_TYPE_New);
  const [applicationSubTypeState,setApplicationSubTypeState]=useState(false);
  const [prePledgeLaon,setPrePledgeLaon]=useState("");
  const [prePledgeLaonState,setPrePledgeLaonState]=useState(false);
  const [prePledgeSubmitDisabled, setPrePledgeSubmitDisabled] = useState("");
  const [disableSubmit ,setDisableSubmit] = useState(false)
  const [textColor,setTextColor]=useState(false);
  const [colletralOperation, setCollateralOperation]= useState(false)
  const [applicantStatus,setApplicantStatus]=useState("");
  const [skipCheckBTIncludeInLoanNumber, setSkipBTTextIncludeInLoanNumber] = useState(false);
  const [showEmailOnApplicantFlag, setShowEmailOnApplicantFlag] = useState(false);
  const [checkForSpuriousGoldFlag, setCheckForSpuriousGoldFlag] = useState(false);
  const [checkForExposureAmountFlag, setCheckForExposureAmountFlag] = useState(false);
  const [checkForTotalOverDueFlag, setCheckForTotalOverDueFlag] = useState(false);
  const [restrictionForMaxLoansFlag, setRestrictionForMaxLoansFlag] = useState(false);
  const [maxLoanLimitFlag, setMaxLoanLimitFlag] = useState(false);
  const [checkForRestrictionFlag, setCheckForRestrictionFlag] = useState(false);
  const [checkForInterestAmountFlag, setCheckForInterestAmountFlag] = useState(false);
  const [validateMaturityDate, setValidateMaturityDate] = useState(false);
  const [checkForUnacceptableItemFlag, setCheckForUnacceptableItemFlag] = useState(false);
  const [convertLoanAccountMunber, setConvertLoanAccountMunber] = useState(false);
  const [enableNegativeProfileCheck, setEnableNegativeProfileCheck] = useState(false);
  const [skipLegalMarkinhValidation, setSkipLegalMarkinhValidation] = useState(true);
  const [skipUnacceptableItemValidationForPartRelease, setSkipUnacceptableItemValidationForPartRelease] = useState(false);
  const [enabledMultiLoanAdjsutmentTopUp, setEnabledMultiLoanAdjsutmentTopUp] = useState([]);
  const [ignoreListData, setIgnoreListData] = useState([]);
  const [exposureAmountFlag, setExposureAmountFlag] = useState('');
  const [repledgeRenewalDays, setRepledgeRenewalDays] = useState('');
  const [applicantRepledgeList, setApplicantRepledgeList]=useState([])
  const [applicantTypeList, setApplicantTypeList]=useState([])
  const [applicantNewList, setApplicantNewList]=useState([]);
  const [applicantBtList, setApplicantBtList]=useState([]);
  const [showModal, setShowModal] = useState(false);
  const [emailVerify, setEmailVerify] = useState("");
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [origionalDisbursalDate, setOrigionalDisbursalDate] = useState(null);
  const [id, setId] = useState("");
  const [isCoreValidationEnabled,setIsCoreValidationEnabled]=useState(true);
  const branchCodeSend = seletedBranchCode ? seletedBranchCode : userDetails?.branchCode;
  const [loanAmountSanctioned, setLoanAmountSanctioned]=useState(0);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [riskPresent,setRiskPresent] = useState(false);
  const [loanAccountNumbers,setLoanAccountNumbers] = useState([]);
  const [selectedLoanAccount,setSelectedLoanAccount] = useState([]);
  const [multiLoanTopUP,setMultiLoanTopup] = useState({});
  console.log(selectedLoanAccount,"selectedLoanAccount");
  const checkForMultiSelect = enabledMultiLoanAdjsutmentTopUp?.includes(applicationSubType);
  useEffect(() => {
    if (
      checkForMultiSelect &&
      selectedLoanAccount?.length > 0
    ) {
      const loanMap = selectedLoanAccount.reduce((acc, selected) => {
        const matchedLoan = loanAccountNumbers.find(
          loan => loan.loanAccountNumber === selected.value
        );

        if (matchedLoan) {
          acc[sanitizeLoanAccountNumber(matchedLoan.loanAccountNumber, convertLoanAccountMunber)] = matchedLoan.netClosureAmt;
        }

        return acc;
      }, {});

      console.log(loanMap, "loanMap");
      setMultiLoanTopup(loanMap);
    }

    if (!checkForMultiSelect && selectedLoanAccount) {
      const selectedValue =
        typeof selectedLoanAccount === "string"
          ? selectedLoanAccount
          : selectedLoanAccount.value;

      const matchedLoan = loanAccountNumbers.find(
        loan => loan.loanAccountNumber === selectedValue
      );

      if (matchedLoan) {
        setMultiLoanTopup({
          [sanitizeLoanAccountNumber(matchedLoan.loanAccountNumber, convertLoanAccountMunber)]: matchedLoan.netClosureAmt,
        });
      }
    }
  }, [
    selectedLoanAccount,
    enabledMultiLoanAdjsutmentTopUp,
    loanAccountNumbers,
    applicationSubType,
  ]);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  useEffect(()=>{
    setApplicantStatus("");
    setReLoanAccountNumber("");
    setMobileNumber("");
    if(applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE){
      setMobileNumber("");
      setEmail("");
    }
  },[applicationSubType])

  // useEffect(() => {
  //   if(applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE && applicationType === APPLICATION_TYPE_BT){
  //       setPrePledgeSubmitDisabled(true)
  //   }else{
  //     setPrePledgeSubmitDisabled("")
  //   }
  // },[applicationSubType,applicationType])

  useEffect(() => {
    getFeatureFlag();
  }, []);
  const getFeatureFlag = async () => {
    const result = await apiHandler({
      url: endpoint.FEATURE_FLAG,
    });
    parseAndSetFlag(result?.data?.enableColletralOperationValidation, setCollateralOperation);
    parseAndSetFlag(result?.data?.checkBTTextInLoanNumber, setSkipBTTextIncludeInLoanNumber)
    parseAndSetFlag(result?.data?.showEmailOnApplicantFlag, setShowEmailOnApplicantFlag)
    parseAndSetFlag(result?.data?.checkForSpuriousGoldFlag, setCheckForSpuriousGoldFlag)
    parseAndSetFlag(result?.data?.checkForExposureAmountFlag, setCheckForExposureAmountFlag)
    parseAndSetFlag(result?.data?.checkForTotalOverDueFlag, setCheckForTotalOverDueFlag)
    parseAndSetFlag(result?.data?.restrictionForMaxLoansFlag, setRestrictionForMaxLoansFlag)
    parseAndSetFlag(result?.data?.checkForRestrictionFlag, setCheckForRestrictionFlag)
    parseAndSetFlag(result?.data?.checkForInterestAmountFlag, setCheckForInterestAmountFlag)
    parseAndSetFlag(result?.data?.validateMaturityDate, setValidateMaturityDate)
    parseAndSetFlag(result?.data?.checkForUnacceptableItemFlag, setCheckForUnacceptableItemFlag)
    parseAndSetFlag(result?.data?.convertLoanAccountMunber, setConvertLoanAccountMunber)
    parseAndSetFlag(result?.data?.enableCheckNegativeProfile, setEnableNegativeProfileCheck)
    parseAndSetFlag(result?.data?.skipLegalMarkinhValidation, setSkipLegalMarkinhValidation)
    parseAndSetFlag(result?.data?.skipUnacceptableItemValidationForPartRelease, setSkipUnacceptableItemValidationForPartRelease)  
    setExposureAmountFlag(result?.data?.exposureAmountFlag);
    setRepledgeRenewalDays(result?.data?.repledgeRenewalDays);
    setMaxLoanLimitFlag(result?.data?.maxLoanLimitFlag);
    const ignoreListSubstatusData = JSON.parse(result?.data?.ignoreCollateralValuationCheck);
    const applicantTypeList= JSON.parse(result?.data?.applicantTypeListFlag)
    const applicantRepledgeSubTypeList = JSON.parse(result?.data?.applicantRepledgeListFlag)
    const applicantNewSubTypeList=JSON.parse(result?.data?.applicantNewSubTypeFlag)
    const applicantBtSubTypeList=JSON.parse(result?.data?.applicantBtSubTypeFlag)
    const enabledMultiLoanAdjsutmentTopUpList=JSON.parse(result?.data?.enabledMultiLoanAdjsutmentTopUp)
    setIgnoreListData(ignoreListSubstatusData);
    setApplicantTypeList(applicantTypeList)
    setApplicantRepledgeList(applicantRepledgeSubTypeList)
    setApplicantBtList(applicantBtSubTypeList)
    setApplicantNewList(applicantNewSubTypeList)
    setEnabledMultiLoanAdjsutmentTopUp(enabledMultiLoanAdjsutmentTopUpList);
  };
  const [emailValidationAttempted, setEmailValidationAttempted] = useState({
        success:false,
        error:false,
      });
  const parseAndSetFlag = (flag, setStateFunction) => {
    const parsedFlag = typeof flag === "boolean" ? flag : flag === "true";
    setStateFunction(parsedFlag);
  };
const dispatch = useDispatch();
  useEffect(() => {
  dispatch(
    saveLoanApplicantDetails({
    applicantDetails: '',
    }),
    );
    dispatch(
    saveLoanDetails({
      ornamentDetail: '',
    })
    );
    dispatch(saveAadharDetails(""));
    dispatch(saveSelfieDetails(""));
    dispatch(saveAadharTransaction(""));
  },[])
  const isValidated = () => {
  if (name === "") {
    setNameState(true);
  } else {
    setNameState(false);
  }

  if (
    mobileNumber === "" ||
    mobileNumber.length > 10 ||
    mobileNumber.length < 10
  ) {
    setMobileNumberState(true);
  } else {
    setMobileNumberState(false);
  }

  if (applicationType === "") {
    setApplicationTypeState(true);
  } else {
    setApplicationTypeState(false);
  }

  if (applicationSubType === "") {
    setApplicationSubTypeState(true);
  } else {
    setApplicationSubTypeState(false);
  }

  if (
    applicationType === APPLICATION_TYPE_BT &&
    applicationSubType === APPLICATION_TYPE_New
  ) {
    setApplicationSubTypeState(true);
    return false;
  } else {
    setApplicationSubTypeState(false);
  }

  if (
    checkForMultiSelect &&
    (!selectedLoanAccount ||
      (Array.isArray(selectedLoanAccount) &&
        selectedLoanAccount.length === 0))
  ) {
    toastUpdate("Error", "Select loan account", true);
    return false;
  }

  if (
    applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE &&
    checkForMultiSelect
  ) {
    const hasBTLoan = selectedLoanAccount?.some((selected) => {
      const loan = loanAccountNumbers.find(
        (item) => item.loanAccountNumber === selected.value
      );

      return loan?.status === "BT";
    });

    if (!hasBTLoan) {
      toastUpdate(
        "Error",
        "At least one BT loan account must be selected",
        true
      );
      return false;
    }
  }

  if (
    name &&
    loanAmount &&
    mobileNumber &&
    mobileNumber.length === 10 &&
    applicationType !== "" &&
    applicationSubType !== ""
  ) {
    return true;
  }

  return false;
};
const loanMarkingCheck = async(customerId, mobileNumber)=>{
    const result = await apiHandler({
      url: endpoint.CHECK_LOAN_MARKING +
      customerId?.trim() + '&mobileNumber=' + mobileNumber,
      method: "GET",
      authToken: authToken,
    });
    if(result?.data?.error_code){
      toastUpdate("Error", result?.data?.user_description  || "No data found", true);
      return
    }else{
      if(result?.data?.legalMarking){
        const loanNumbers = result?.data?.loanValidationDetails.map((loan) => loan.loanAccountNumber).join(", ");
        toastUpdate("Error", `Firstly remove the legal marking on ${loanNumbers}`, true);
        return false
      }else{
        return true
      }
    }
  }
  const mobileGetData = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.GET_ALL_DATA_MOBILE_NUMBER,
      authToken: authToken,
      method:"POST",
      data: {
        mobileNumber: mobileNumber,
        source: "WEB",
        renewalFlag:applicationSubType === repledgeCaseListName?.renew ? true : false,
        toupFlag:applicationSubType === repledgeCaseListName?.topUp ? true : false,
        includeBtLoans: applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE ? true : false
      }
    });
    setCallInProgress(false);
    if(res?.data?.error_code){
      toastUpdate("Error", res?.data?.user_desption, true);
      setDisableSubmit(true);
      return false
    }else{
     const getAllActiveLoans = res?.data
        ?.filter((item) => item.status === "ACTIVE" || item.status === "BT")
        ?.sort((a, b) => (a.status === "BT" ? -1 : 1));   
      setLoanAccountNumbers(getAllActiveLoans);
    }
  }
  const checkRestriction = async (value, bluredMobile) => {
    const result = await apiHandler({
      url: endpoint.CHECK_PROFILE_RESTRICTION + value,
      authToken: authToken,
    });
  
    if (!result?.data?.error_code) {
     if(Number(result?.data?.totalDisbursedLoanAmt) - loanAmountSanctioned > Number(exposureAmountFlag) && checkForExposureAmountFlag){
        toastUpdate("Error", `For this customer exposure is getting more than ${Number(exposureAmountFlag)}`, true);
        setDisableSubmit(true);
        return false
      }
      const activeLoans = result?.data?.restrictions?.filter((item)=>item?.status === 'ACTIVE' || item?.status === "UNDER_CLOSURE");
      const maxLoanCount = applicationType === APPLICATION_TYPE_RE_PLEDGE ? Number(maxLoanLimitFlag) + 1 : Number(maxLoanLimitFlag);
      if(activeLoans?.length >= Number(maxLoanCount) && restrictionForMaxLoansFlag){
        toastUpdate("Error", `Maximum number of loan limit already reached`, true);
        setDisableSubmit(true);
        return false
      }
      if (
        (applicationSubType === repledgeCaseListName?.renew ||
         applicationSubType === repledgeCaseListName?.topUp) &&
        isCoreValidationEnabled
      ) {
        const dueDiligenceCases = result?.data?.restrictions?.filter(
          entry => entry?.dueDiligence && entry?.dueDiligence.trim() !== ''
        );
      
        if (dueDiligenceCases?.length > 0) {
          const message = dueDiligenceCases
            .map(loan =>
              `For this customer, against ${loan.loanAccountNumber} Due Diligence: ${loan.dueDiligence}.`
            )
            .join('\n');
          
          toastUpdate("Warning", message, true);
          return true;
        }else{
          return true
        }
      }else{
      const deathOrLegalAccounts = result?.data?.restrictions
        .filter(entry => {
        const loanMarkingAction = entry?.loanMarkingAction || "";
        const loanAuditActions = entry?.loanAuditActions || [];
        const hasSpuriousGold =
          loanAuditActions?.some(
            action =>
              action === `[${CHECK_LOAN_MARKINGS.spuriousGold}]` ||
              action === CHECK_LOAN_MARKINGS.spuriousGold
          );
        
        const hasUnacceptableItem =
          checkForUnacceptableItemFlag &&
          !(
            skipUnacceptableItemValidationForPartRelease &&
            (applicationSubType === repledgeCaseListName?.partRelease || applicationSubType === repledgeCaseListName?.renew)
          ) &&
          loanAuditActions?.some(
            action =>
              action === `[${CHECK_LOAN_MARKINGS.unacceptableItem}]` ||
              action === CHECK_LOAN_MARKINGS.unacceptableItem
          );
        return (
            loanMarkingAction.includes(CHECK_LOAN_MARKINGS.death) ||
            loanMarkingAction.includes(CHECK_LOAN_MARKINGS.legal) ||
            (entry?.npa === true && entry?.status !== LOAN_STATUS_CLOSED) ||
            (hasSpuriousGold && entry?.status !== LOAN_STATUS_CLOSED) ||
            (hasUnacceptableItem && entry?.status !== LOAN_STATUS_CLOSED) ||
            (entry?.dueDiligence && entry?.dueDiligence.trim() !== '')
        );
    });
    const filteredCases = deathOrLegalAccounts.filter(loan => {
      const loanAuditActions = loan?.loanAuditActions || [];
      const hasSpuriousGold =
        loanAuditActions.includes(CHECK_LOAN_MARKINGS.spuriousGold);
      const hasUnacceptableItem =
        checkForUnacceptableItemFlag &&
        !(
          skipUnacceptableItemValidationForPartRelease &&
          applicationSubType === repledgeCaseListName?.partRelease
        ) &&
        loanAuditActions.includes(CHECK_LOAN_MARKINGS.unacceptableItem);   
      return (
          (loan?.status !== LOAN_STATUS_CLOSED && 
          (hasSpuriousGold || hasUnacceptableItem)) ||
          loan?.loanMarkingAction === CHECK_LOAN_MARKINGS.death || 
          loan?.loanMarkingAction === CHECK_LOAN_MARKINGS.legal ||
          (loan?.npa === true && loan?.status !== LOAN_STATUS_CLOSED) ||
          (loan?.dueDiligence && loan?.dueDiligence.trim() !== '')
      );
  });
  
      const formatAction = (action) => {
        switch (action) {
          case CHECK_LOAN_MARKINGS.spuriousGold:
            return 'SPURIOUS GOLD';
            case CHECK_LOAN_MARKINGS.unacceptableItem:
            return 'UNACCEPTABLE ITEM';
          default:
            return action;
        }
      };
  
      const groupedMessages = filteredCases?.reduce((acc, loan) => {
        const formattedAuditActions = loan?.loanAuditActions
          ?.filter(action => action === CHECK_LOAN_MARKINGS.spuriousGold ||
            (checkForUnacceptableItemFlag &&
                !(
                  skipUnacceptableItemValidationForPartRelease &&
                  applicationSubType === repledgeCaseListName?.partRelease
                ) &&
                action === CHECK_LOAN_MARKINGS.unacceptableItem
              ))
          ?.map(formatAction)
          ?.join(', ');
  
        const formattedMarkingAction = (loan?.loanMarkingAction === CHECK_LOAN_MARKINGS.death || loan?.loanMarkingAction === CHECK_LOAN_MARKINGS.legal) ?
          loan.loanMarkingAction : '';
  
        const npaStatus = loan?.npa ? 'NPA' : '';
        const dueDiligence = loan?.dueDiligence ? `Due Diligence: ${loan.dueDiligence}` : '';
  
        const messageParts = [];
        if (formattedAuditActions) messageParts.push(formattedAuditActions);
        if (formattedMarkingAction) messageParts.push(formattedMarkingAction);
        if (npaStatus) messageParts.push(npaStatus);
        if (dueDiligence) messageParts.push(dueDiligence);
  
        const messageContent = messageParts.join(' and ');
  
      const message = `For this customer, against ${loan.loanAccountNumber} loan status is ${messageContent}.\n`;
  
        if (!acc.processedAccounts.has(loan.loanAccountNumber)) {
          if (acc.groupedMessages[loan.loanAccountNumber]) {
            acc.groupedMessages[loan.loanAccountNumber].push(message);
          } else {
            acc.groupedMessages[loan.loanAccountNumber] = [message];
          }
          acc.processedAccounts.add(loan.loanAccountNumber);
        }
  
        return acc;
      }, { groupedMessages: {}, processedAccounts: new Set() });
  
      const noticeMessages = Object.entries(groupedMessages.groupedMessages).map(([accountNumber, messages]) => {
        return messages.join('');
      }).join('');
  
      const joinLoanAccountNumber = Object.keys(groupedMessages.groupedMessages).join(', ');
      if (joinLoanAccountNumber && (!checkForRestrictionFlag || (checkForRestrictionFlag && result?.data?.restriction))) {
        toastUpdate("Error", noticeMessages, true);
        setDisableSubmit(true)
      }else {
    setDisableSubmit(false)
    if(!bluredMobile){
      CreateLoanAccount();
      }
      }
    }
  }
  }

  const OnSubmit = async (id) => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.SEARCH_PROFILE + mobileNumber,
        authToken: authToken,
      });
      setCallInProgress(false);
      if (res?.data?.length > 1) {
        const customerIds = res?.data?.map(customer => customer.customerId);
        const customerIdsString = customerIds.join(', ');
        setApplicantStatus(`Multiple Customer id ${customerIdsString} exists with same mobile number. Kindly correct the same before new loan creation.`);
        setDisableSubmit(true)
        setTextColor(true);
      } else {
        if(res?.data?.length === 1){
          setApplicantStatus(`Existing customer with Customer ID ${res?.data?.[0]?.customerId}`);
          setDisableSubmit(false)
          setTextColor(false)
           if (
          (applicationSubType === repledgeCaseListName?.renew ||
          applicationSubType === repledgeCaseListName?.topUp) &&
          isCoreValidationEnabled
        ) {
            CreateLoanAccount();
        }else{
          checkRestriction(res?.data?.[0]?.customerId);
        }
        }else{
          setApplicantStatus("New Customer");
          setDisableSubmit(false);
        setTextColor(false)
        CreateLoanAccount();
        }
      }
    } else {
      if (
      checkForMultiSelect &&
      (!selectedLoanAccount ||
        (Array.isArray(selectedLoanAccount) && selectedLoanAccount.length === 0))
    ) {
      toastUpdate("Error", "Select loan account", true);
      return false;
    }
    if (
      applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE &&
      checkForMultiSelect
    ) {
      const hasBTLoan = selectedLoanAccount?.some((selected) => {
        const loan = loanAccountNumbers.find(
          (item) => item.loanAccountNumber === selected.value
        );
      
        return loan?.status === "BT";
      });
    
      if (!hasBTLoan) {
        toastUpdate(
          "Error",
          "At least one BT loan account must be selected",
          true
        );
        return false;
      }
    }
      toastUpdate("Error", "Enter Valid input field", true);
    }
  };
  const onBlurMobileNumber = async () =>{
    if (!mobileNumber || mobileNumber.length < 10 || mobileNumber.length > 10) {
      setMobileNumberState(true);
      return;
    }
    if(enableNegativeProfileCheck){
      const apiReponse = await checkNegativeProfileApi(apiHandler,
            endpoint,
            authToken,
            setCallInProgress,
            toastUpdate,
            null,
            null,
            mobileNumber)
             if (apiReponse?.[0]?.risk) {
              proceedApplication();
            }
    }
    const res = await apiHandler({
      url: endpoint.SEARCH_PROFILE + mobileNumber,
      authToken: authToken,
    });
    if (res?.data?.length > 1) {
      const customerIds = res?.data?.map(customer => customer.customerId);
      const customerIdsString = customerIds.join(', ');
      setApplicantStatus(`Multiple Customer id ${customerIdsString} exists with same mobile number. Kindly correct the same before new loan creation.`);
      setDisableSubmit(true)
      setTextColor(true)
    } else if(res?.data?.length === 1){
      if(!skipLegalMarkinhValidation){
        const marking = await loanMarkingCheck(
          res?.data?.[0]?.customerId,
          mobileNumber
        );
        if (!marking) {
          return;
        }
      }
        if(applicationSubType === repledgeCaseListName?.topUp || 
          applicationSubType === repledgeCaseListName?.renew || 
          applicationSubType === repledgeCaseListName?.partRelease ||
          applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE){
          mobileGetData(res?.data?.[0]?.customerId, "bluredMobileNumber");
        }else{
          checkRestriction(res?.data?.[0]?.customerId, "bluredMobileNumber");
        }
        if(res?.data?.[0]?.communication?.primaryEmail && res?.data?.[0]?.communication?.primaryEmail !== null && typeof res?.data?.[0]?.communication?.primaryEmail !== "undefined"){
          setEmail(res?.data?.[0]?.communication?.primaryEmail);
          setIsEmailVerified(true);
        }else{
          setIsEmailVerified(false);
        }
        setDisableSubmit(false)
        setTextColor(false)
        setApplicantStatus(`Existing customer with Customer ID ${res?.data?.[0]?.customerId}`);
 }
    else{
        setApplicantStatus("New Customer");
        setTextColor(false);
        setDisableSubmit(false);
        setIsEmailVerified(false);
    }
  }

  const checkForTopAndRenwalEligible = async (
    mobileNum,
    loanAccountNumber,
    subType
  ) => {
    setCallInProgress(true);

    const isTopUp = subType === repledgeCaseListName?.topUp;
    const isRenewal = subType === repledgeCaseListName?.renew;

    const loanDetails = await apiHandler({
      url:
        endpoint.GET_LOAN_TOP_AND_RENEAL_DETAILS +
        mobileNum +
        `/renewal/${isRenewal}/topup/${isTopUp}?source=WEB&loanAccountNumber=${loanAccountNumber}`,
      method: "GET",
      authToken,
    });

    setCallInProgress(false);

    if (loanDetails?.data?.error_code) {
      toastUpdate("Error", loanDetails?.data?.user_description, true);
      return false;
    }
    if (!loanDetails?.data?.length) {
      toastUpdate("Error", "No Data Found", true);
      return false;
    }
    if (!Array.isArray(loanDetails?.data)) return true;
    const AllLoanDetails = loanDetails?.data;
    const loan = AllLoanDetails?.find((item)=> item.loanAccountNumber === loanAccountNumber)
    const hasFeatureDisabled = loan?.topUpDenialReason === "FEATURE_DISABLED" || loan?.renewableDenialReason === "FEATURE_DISABLED";
    if (hasFeatureDisabled) {
        toastUpdate("Error", `${subType} feature is disabled`, true);
          return false;
    }
    if (loan?.loanStatus === "CLOSED") {
      toastUpdate("Error", "Loan is closed", true);
      return false;
    }
      if (
      (isTopUp && loan?.topupEligible === false) ||
      (isRenewal && loan?.renewalEligible === false)
    ) {
        const denialReason = isTopUp ? loan?.topUpDenialReason : loan?.renewableDenialReason;
        const type = isRenewal ? "Renewal" : "TopUp"
        if(denialReason){
            toastUpdate("Error", getDenialMessage(denialReason, AllLoanDetails, type, denialReasonsList, CHECK_LOAN_MARKINGS), true)
          }else{
            toastUpdate("Error", `You are not eligible for ${type}`, true)
          }
        return false
    }else{
       const restrictionCheck = await checkRestriction(loan?.customerId, "bluredMobileNumber");
       if(restrictionCheck){
        if(enableNegativeProfileCheck){
            const apiReponse = await checkNegativeProfileApi(apiHandler,
                  endpoint,
                  authToken,
                  setCallInProgress,
                  toastUpdate,
                  null,
                  null,
                  mobileNum)
                   if (apiReponse?.[0]?.risk) {
                    proceedApplication();
                  }
          }
        setMobileNumber(mobileNum);
        setPrePledgeSubmitDisabled(false);
        setDisableSubmit(false);
        return true;
       }
    }
  };

 const GetoutstandingDatas = async (loanAccountNumber, status) => {
  if (loanAccountNumber === "") return;
  const matchLoanAccount = loanAccountNumber.slice(0, 3);
  if (status === loanApplicationStatusNamesList?.rePledge) {
    const checkResult = await checkForRepledgeAccount(
      authToken,
      loanAccountNumber
    );
    if (checkResult?.data?.error_code) {
      toastUpdate("Error", checkResult?.data?.user_description, true);
      return;
    } else {
      if (Array.isArray(checkResult?.data) && checkResult.data.length > 0) {
        const ids = checkResult.data.map((item) => item?.id).filter(Boolean);
        const idsText = ids.length > 0 ? ` Lead Ids: ${ids.join(", ")}` : "";
        toastUpdate(
          "Error",
          `Already Repledge Loan Present with ${idsText}`,
          true
        );
        return false;
      }
    }
  }
  if (
    (matchLoanAccount === "BTG" &&
      status === loanApplicationStatusNamesList?.btLoan &&
      !skipCheckBTIncludeInLoanNumber) ||
    status === loanApplicationStatusNamesList?.rePledge ||
    (skipCheckBTIncludeInLoanNumber &&
      status === loanApplicationStatusNamesList?.btLoan)
  ) {
    const outstandingresult = await apiHandler({
      url:
        endpoint.CHECK_LOAN_STATUS +
        "?loanAccountNumber=" +
        loanAccountNumber?.toUpperCase(),
      method: "GET",
      authToken: authToken,
    });
    if (outstandingresult?.data?.error_code) {
      toastUpdate("Error", outstandingresult?.data?.user_description, true);
      setPrePledgeLaon("");
      setApplicantStatus("");
      setTextColor(false);
      setPrePledgeSubmitDisabled(true);
    } else {
      if (
        outstandingresult?.data?.collateralLoacation !==
          collateralOperationStatus?.inBranch &&
        outstandingresult?.data?.collateralLoacation !==
          collateralOperationStatus?.receivedFromHO &&
        status === loanApplicationStatusNamesList?.rePledge &&
        !ignoreListData?.includes(applicationSubType) &&
        colletralOperation
      ) {
        setApplicantStatus("Requested loan collateral is not in branch");
        setPrePledgeLaon("");
        setTextColor(true);
        setPrePledgeSubmitDisabled(true);
        return;
      } else if (
        applicationSubType === repledgeCaseListName?.renew ||
        applicationSubType === repledgeCaseListName?.topUp
      ) {
        checkForTopAndRenwalEligible(
          outstandingresult?.data?.mobileNumber?.trim(),
          loanAccountNumber,
          applicationSubType
        );
      } else {
        if(status === loanApplicationStatusNamesList?.rePledge){
          setLoanAmountSanctioned(Number(outstandingresult.data.loanAmountSanctioned))
        }
        const renewalInterestCase =
          status === loanApplicationStatusNamesList?.rePledge &&
          applicationSubType === repledgeCaseListName?.renew &&
          checkForInterestAmountFlag;
        const maturityDate = new Date(outstandingresult?.data?.maturityDate);
        const renewalMaturityDate = getPreviousDateFromTheMaturityAccToDays(
          outstandingresult?.data?.maturityDate,
          repledgeRenewalDays
        );
        setOrigionalDisbursalDate(
          outstandingresult?.data?.origional_disbursal_date
        );
        const hasInterestPending = outstandingresult?.data?.isInterestPending;
        const isMatured =
          validateMaturityDate &&
          !isNaN(renewalMaturityDate) &&
          getDateOnly(renewalMaturityDate) > getDateOnly(new Date());
        if (
          validateMaturityDate &&
          !isNaN(maturityDate) &&
          getDateOnly(maturityDate) < getDateOnly(new Date()) &&
          applicationType !== APPLICATION_TYPE_BT &&
          !renewalInterestCase
        ) {
          toastUpdate(
            "Error",
            `Adjusted account number ${loanAccountNumber} is matured`,
            true
          );
          setApplicantStatus("");
          setTextColor(false);
          setPrePledgeSubmitDisabled(false);
        } else if ((hasInterestPending || isMatured) && renewalInterestCase) {
          if (hasInterestPending) {
            toastUpdate(
              "Error",
              `Interest is still due on adjusted loan account number ${loanAccountNumber}`,
              true
            );
          }
          if (isMatured) {
            toastUpdate(
              "Error",
              `${loanAccountNumber} is not matured yet`,
              true
            );
          }
          setApplicantStatus("");
          setTextColor(false);
          setPrePledgeSubmitDisabled(true);
        } else if (
          outstandingresult?.data?.loanStatus !== APPLICATION_TYPE_BT &&
          status === loanApplicationStatusNamesList?.btLoan &&
          !renewalInterestCase
        ) {
          toastUpdate(
            "Error",
            `Loan Account status is ${outstandingresult?.data?.loanStatus}`,
            true
          );
          setApplicantStatus("");
          setTextColor(false);
          setPrePledgeLaon("");
          setPrePledgeSubmitDisabled(true);
        } else if (
          outstandingresult?.data?.loanStatus?.toLowerCase() ===
            LOAN_STATUS_CLOSED?.toLowerCase() &&
          status === loanApplicationStatusNamesList?.rePledge
        ) {
          toastUpdate("Error", `Loan Account status is closed`, true);
          setApplicantStatus("");
          setTextColor(false);
          setPrePledgeLaon("");
          setPrePledgeSubmitDisabled(true);
        } else if (
          outstandingresult?.data?.totaloverdue > 0 &&
          status === loanApplicationStatusNamesList?.rePledge &&
          checkForTotalOverDueFlag &&
          !renewalInterestCase
        ) {
          toastUpdate("Error", `Total Overdue is greater than 0`, true);
          setApplicantStatus("");
          setTextColor(false);
          setPrePledgeLaon("");
          setPrePledgeSubmitDisabled(true);
        } else if (
          outstandingresult?.data?.loanStatus?.toLowerCase() !==
          LOAN_STATUS_CLOSED?.toLowerCase()
        ) {
          setApplicantStatus("");
          setTextColor(false);
          if(enableNegativeProfileCheck){
            const apiReponse = await checkNegativeProfileApi(apiHandler,
                  endpoint,
                  authToken,
                  setCallInProgress,
                  toastUpdate,
                  null,
                  null,
                  outstandingresult?.data?.mobileNumber?.trim())
                   if (apiReponse?.[0]?.risk) {
                    proceedApplication();
                  }
          }
          setMobileNumber(outstandingresult?.data?.mobileNumber?.trim());
          if (
            outstandingresult?.data?.email &&
            typeof outstandingresult?.data?.email !== "undefined"
          ) {
            setEmail(outstandingresult?.data?.email);
          }
          setPrePledgeSubmitDisabled(false);
        } else if (status === loanApplicationStatusNamesList?.btLoan) {
          setApplicantStatus("");
          setTextColor(false);
          setPrePledgeSubmitDisabled(false);
        } else {
          setPrePledgeSubmitDisabled(false);
        }
      }
    }
  } else {
    toastUpdate("Error", `Enter Valid Loan Account Number`, true);
    setPrePledgeLaon("");
    setPrePledgeSubmitDisabled(true);
  }
};

  const CreateLoanAccount = async () => {

      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.ADMIN_STARTAPPLICATION_SUBMIT,
        method: "POST",
        authToken: authToken,
        data: {
          loanAmount: loanAmount,
          name: name,
          mobileNumber: mobileNumber?.trim(),
          appointment: appointmentDate,
          pincode: null,
          email: email ? email?.toLowerCase(): "",
          address: "",
          city: "",
          state: "",
          country: "",
          branchCode: branchCodeSend,
          applicationType: applicationType,
          applicationSubType: applicationSubType,
          prepledgeLoanAccountNumber: reLoanAccoutnNumber?.toUpperCase(),
          initiator:'BRANCH',
          prepledgeLoanMap: 
          (
            applicationSubType === repledgeCaseListName?.topUp 
            || applicationSubType === repledgeCaseListName?.renew
          || applicationSubType === repledgeCaseListName?.partRelease || 
        applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE) 
            ? multiLoanTopUP : {},
          ...(applicationType === APPLICATION_TYPE_RE_PLEDGE && {
            origionalDisbursalDate,
          }),
        },
      });
      setCallInProgress(false);
      //ADMIN_STARTAPPLICATION_SUBMIT

      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        AssignTaskToAgent(res?.data?.id);
        setLoanApplicationId(res?.data?.id);
      }
   
  };
  const AssignTaskToAgent = async (id) => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.ADMIN_APPLICATION_ASSIGN,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: id,
        assigneeUsername: userDetails?.username,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    } else {
      onActionClickAssignedStart(id);
    }
  };
  const sendEMailOtp = async () => {
      const res = await apiHandler({
        url: endpoint.APPLICANT_EMAIL_OTP,
        method: "POST",
        authToken: authToken,
        data: {
          type: "EMAIL",
          source: email?.toLowerCase(),
          messageType: 0,
          otp: "null",
        },
      });
      setId(res?.data?.id);
      if (res?.data?.id) {
        setShowModal(true);
      }
    };
    const verifyOtp = async (otp) => {
      const res = await apiHandler({
        url: endpoint.APPLICANT_EMAIL_VERIFY + id + "/" + otp,
        method: "POST",
        authToken: authToken,
      });
      setShowModal(false);
      if(res?.data?.error_code) {
        setEmailValidationAttempted({error:true});
        setEmailVerify("error");
        toastUpdate("Error", res?.data?.user_description, true);
        setTimeout(() => {
          setShowModal(true);
        },3000)
      }
      else{
        setShowModal(false);
        setEmailVerify("success");
        setEmailValidationAttempted({success:true});
        toastUpdate("Success", "Email verified successfully", true);
      }
    };
  const onActionClickAssignedStart = async (id) => {
    setCallInProgress(true);
    const response = await apiHandler({
      url: endpoint.ADMIN_APPLICANTION_STARTTASK,
      method: "PUT",
      authToken: authToken,
      data: {
        loanApplicationId: id,
      },
    });
    setCallInProgress(false);
      if (response?.data?.error_code) {
      toastUpdate("Error", response?.data?.user_description, true);
      return;
    } else {
      setIsOtpMode(true);
    }
  };
  /**  */
  const validatecode = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    setCallInProgress(true);
    //ADMIN_VERFICAION_OTP
    const res = await apiHandler({
      url: endpoint.ADMIN_VERFICAION_OTP,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
        otp: otpValidation,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error",'Kindly verify the otp or resend the otp', true);
      return;
    } else {
      closeModal("modal");
      navigate("/loanservice/inProcess", {state: {from: ''}});
      GetData();
    }
  };
  /**  */
  const resendcode = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    //ADMIN_APPLICANTION_STARTTASK
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.ADMIN_APPLICANTION_STARTTASK,
      method: "PUT",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    } else {
      toastUpdate("Success", "OTP Sent Successfully", true);
    }

    setIsOtpMode(true);
  };

  const OnClose = () => {
    closeModal();
  };
  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setMobileNumber(e);
    }
  };
  const handleChangeType = (e)=>{
    if(e === APPLICATION_TYPE_New){
      setApplicationType(e);
      setApplicationSubType(e);
      setReLoanAccountNumber("");
      setPrePledgeLaon("")
      setApplicantStatus("");
    }else if(e === APPLICATION_TYPE_BT){
      setReLoanAccountNumber("")
      setApplicationType(e);
      setMobileNumber("");
      setEmail("");
      setApplicantStatus("");
    }else {
      setApplicationType(e);
      setMobileNumber("");
      setEmail("");
      setApplicantStatus("");
    }
  }
   const handleClose = () => {
    setShowModal(false);
    setEmailVerify("error");
  };
  const closeConfirmationModal = () => {
       setConfirmationModal(false);
       setConfirmationModalHeader("");
       setConfirmationModalMsg("");
     };
     
     const handleNegativeResponse = () => {
       closeConfirmationModal();
       setRiskPresent(true);
     };
     
     const handlePositiveResponse = () => {
       closeConfirmationModal();
       setRiskPresent(false);
     };
    const proceedApplication = () => {
      setConfirmationModalHeader("Risk Warning");
      setConfirmationModalMsg(
        "Customer is in negative list, Do you want to proceed"
      );
      setConfirmationModal(true);
    };
    const validateSelectedLoan = async (loanAccountNumber) => {
  if (applicationType === APPLICATION_TYPE_RE_PLEDGE) {
    const checkResult = await checkForRepledgeAccount(
      authToken,
      sanitizeLoanAccountNumber(
        loanAccountNumber,
        convertLoanAccountMunber
      )
    );

    if (checkResult?.data?.error_code) {
      toastUpdate(
        "Error",
        checkResult?.data?.user_description,
        true
      );
      return false;
    }

    if (
      Array.isArray(checkResult?.data) &&
      checkResult.data.length > 0
    ) {
      const ids = checkResult.data
        .map((item) => item?.id)
        .filter(Boolean);

      const idsText =
        ids.length > 0 ? ` Lead Ids: ${ids.join(", ")}` : "";

      toastUpdate(
        "Error",
        `Already Repledge Loan Present with ${idsText}`,
        true
      );
      return false;
    } else if (
      applicationSubType === repledgeCaseListName?.partRelease
    ) {
      await GetoutstandingDatas(
        loanAccountNumber,
        "rePledge"
      );
    }
  }

  const selectedLoan = loanAccountNumbers.find(
    (item) => item.loanAccountNumber === loanAccountNumber
  );

  if (!selectedLoan) return false;

  const isPostPledge =
    applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE;

  const isActive = selectedLoan.status === "ACTIVE";
  const isBT = selectedLoan.status === "BT";

  if (isPostPledge) {
    if (!isActive && !isBT) {
      toastUpdate("Error", "Invalid loan status", true);
      return false;
    }

    if (isActive && !selectedLoan.toupEligibility) {
      toastUpdate(
        "Error",
        removeUnderscoresAndCapitalize(
          selectedLoan.toupEligibilityDenialReason
        ) || "TopUp not eligible",
        true
      );
      return false;
    }
  } else {
    if (!isActive) {
      toastUpdate("Error", "Loan is inactive", true);
      return false;
    }

    if (
      applicationSubType === repledgeCaseListName?.topUp &&
      !selectedLoan.toupEligibility
    ) {
      toastUpdate(
        "Error",
        removeUnderscoresAndCapitalize(
          selectedLoan.toupEligibilityDenialReason
        ) || "TopUp not eligible",
        true
      );
      return false;
    }
  }

  if (
    applicationSubType === repledgeCaseListName?.renew &&
    !selectedLoan.renewalEligibility
  ) {
    toastUpdate(
      "Error",
      removeUnderscoresAndCapitalize(
        selectedLoan.renewalEligibilityDenialReason
      ) || "Renewal not eligible",
      true
    );
    return false;
  }

  if (
    selectedLoan.collateralLocation !==
      collateralOperationStatus?.inBranch &&
    selectedLoan.collateralLocation !==
      collateralOperationStatus?.receivedFromHO &&
    colletralOperation
  ) {
    toastUpdate(
      "Error",
      "Collateral is not in branch",
      true
    );
    return false;
  }

  return true;
};
const filteredLoanAccountNumbers =
  applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE
    ? loanAccountNumbers.filter((item) => item.status === "BT")
    : loanAccountNumbers.filter((item) => item.status !== "BT");
 const isPostPledge =
  applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE;
const maskedMobileNumberLoanTypes = (applicationType === APPLICATION_TYPE_BT && applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE);
  return (
      <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label="Create Application"
          message={applicantStatus}
          colorFlag={textColor}
        />
      </Grid>
      
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
              label="Name"
              required
              id="name"
              error={nameState}
              value={textFormat(name)}
              setState={setName}
              setError={setNameState}
              disabled={isOtpMode}
            />
            </Grid>
            <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Select Loan Amount*"
              value={loanAmount}
              id="selected_loan_amount"
              setState={setLoanAmount}
              data={loanAmountList}
              type="loan"
              disabled={isOtpMode}
            />
          </Grid>
            <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Application Type*"
              id="applicant_type"
              error={applicationTypeState}
              setError={setApplicationTypeState}
              value={applicationType}
              setState={handleChangeType}
              data={applicantTypeList}
              type="type"
              disabled={isOtpMode}
            />
          </Grid>
            <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Application Subtype*"
              id="applicant_subtype"
              error={applicationSubTypeState}
              setError={setApplicationSubTypeState}
              value={applicationType===APPLICATION_TYPE_New ? APPLICATION_TYPE_New: applicationSubType}
              setState={setApplicationSubType}
              data={applicationType=== APPLICATION_TYPE_New ? applicantNewList : applicationType === APPLICATION_TYPE_BT ? applicantBtList : applicantRepledgeList}
              type="type"
              disabled={isOtpMode || applicationType === APPLICATION_TYPE_New}
            />
          </Grid>
          {/* {applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE && applicationType === APPLICATION_TYPE_BT &&
            <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
              label="Pre Pledge Loan Account Number"
              required
              id="pre_pledge_loan_account_number"
              error={prePledgeLaonState}
              value={prePledgeLaon?.toUpperCase()}
              setState={setPrePledgeLaon}
              type="notCapital"
              setError={setPrePledgeLaonState}
              setBlur={(e)=> GetoutstandingDatas(e, loanApplicationStatusNamesList?.btLoan)}
              disabled={isOtpMode}
            />
          </Grid>} */}
          {/* {((applicationType === APPLICATION_TYPE_RE_PLEDGE && applicationSubType === repledgeCaseListName?.partRelease ))&&
            <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
              label="Loan Account Number"
              required
              id="`loan_account_number"
              error={prePledgeLaonState}
              value={reLoanAccoutnNumber?.toUpperCase()}
              setState={setReLoanAccountNumber}
              type="notCapital"
              setError={setPrePledgeLaonState}
              setBlur={(e)=> {
                  GetoutstandingDatas(e, 'rePledge')}
              }
              disabled={isOtpMode}
            />
          </Grid>
          } */}
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
              label="Mobile number"
              required
              id="mobile_number"
              error={mobileNumberState}
              value={ mobileNumber}
              setState={handleChange}
              maxLength="10"
              setBlur={onBlurMobileNumber}
              setError={setMobileNumberState}
              disabled={isOtpMode}
            />
            </Grid>
            {(applicationType === APPLICATION_TYPE_RE_PLEDGE || applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE) && 
              ( checkForMultiSelect ?
              <Grid xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                <FormControl fullWidth>
                  <InputLabel className={classes.labelStyle}>
                  Select Loan Accounts*
                  </InputLabel>
                  <MSelect
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    isMulti
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                      menuList: (base) => ({
                      ...base,
                      maxHeight: 250,
                      overflowY: "auto",
                    }),
                    }}
                    onChange={async (e) => {
                      const validatedLoans = [];
                      for (const item of e) {
                        const isValid = await validateSelectedLoan(item.value);
                        if (isValid) {
                          validatedLoans.push(item);
                        }
                      }
                      setSelectedLoanAccount(validatedLoans);
                    }}
                    options={loanAccountNumbers.map((item) => {
                    let reason = "";
                                      
                    if (isPostPledge) {
                      if (
                        item.status === "ACTIVE" &&
                        !item.toupEligibility
                      ) {
                        reason =
                          removeUnderscoresAndCapitalize(
                            item.toupEligibilityDenialReason
                          ) || "Not eligible";
                      }
                    } else {
                      if (item.status !== "ACTIVE") {
                        reason = "Inactive";
                      } else if (!item.toupEligibility) {
                        reason =
                          removeUnderscoresAndCapitalize(
                            item.toupEligibilityDenialReason
                          ) || "Not eligible";
                      } else if (
                        item?.collateralLocation !==
                          collateralOperationStatus?.inBranch &&
                        item?.collateralLocation !==
                          collateralOperationStatus?.receivedFromHO &&
                        applicationType === loanApplicationStatusNamesList?.rePledge &&
                        !ignoreListData?.includes(applicationSubType) &&
                        colletralOperation
                      ) {
                        reason = "Collateral is not in branch";
                      }
                    }

                      return {
                        value: item.loanAccountNumber,
                        label: reason
                          ? `${item.loanAccountNumber} - ${reason}`
                          : item.loanAccountNumber,
                        isDisabled: !!reason,
                      };
                    })}
                  />
                </FormControl>
              </Grid>
              :
              <>
              {/* {applicationSubType !== repledgeCaseListName?.partRelease && */}
                  <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
                    <CustomSelectNew
                      label="Select Loan Account*"
                      id="applicant_subtype"
                      value={selectedLoanAccount}
                      setState={async (value) => {
                        const selectedValue =
                          typeof value === "string" ? value : value?.value;               
                        const isValid = await validateSelectedLoan(selectedValue);
                        if (isValid) {
                          setSelectedLoanAccount(value);
                        }
                      }}
                      data={filteredLoanAccountNumbers}
                      type="loanAccountNumbers"
                      disabled={isOtpMode}
                    />
                  </Grid>
                {/* } */}
              </>
              )
            }
            {showEmailOnApplicantFlag &&
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr} style={{ position: "relative" }}>
          <CustomeTextField
              label="Email"
              value={email?.toLowerCase()}
              id="email"
              setState={setEmail}
              disabled={isOtpMode || applicationType ===  APPLICATION_TYPE_RE_PLEDGE ||( applicationType === APPLICATION_TYPE_BT && applicationSubType === APPLICATION_SUB_TYPE_POST_PLEDGE)}
              type='notCapital'
              validationState={emailValidationAttempted}
            />
            {(!isEmailVerified && applicationType === APPLICATION_TYPE_New) && <Button
              disabled={emailVerify === "success"}
              size="small"
              style={{
                height: "40px",
                width: "75px",
                position: "absolute",
                right: 0,
                top: 0,
                margin:0,
                backgroundColor:brandTheme.button2Color,
                color:brandTheme.white
              }}
             onClick={() => sendEMailOtp()}  
            >
              Verify
            </Button>}
            </Grid>
            }
            </Grid>
            </Grid>
      <GridContainer style={{ marginTop: 40 }}>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} >
             {!isOtpMode &&  <Button
                // style={{ margin: "5px" ,backgroundColor:'#2f2f2f'}}
                size="small"
                // color="info"
                // className="bg-gradient-theme-left border-0"
                className={classes.nextButton}
                disabled={callInProgress || prePledgeSubmitDisabled || disableSubmit || (showEmailOnApplicantFlag && !isEmailVerified && applicationType === APPLICATION_TYPE_New && email !== "" && emailVerify !== "success") || (!mobileNumber || mobileNumber.length <10 || mobileNumber.length >10) || riskPresent}
                onClick={(event) => OnSubmit(event)}
              >
                Submit
              </Button>
}
              <Button
                // style={{ margin: "5px" }}
                size="small"
                className={classes.nextButton1}
                // color="gray"
                // className="bg-gradient-theme-left border-0"
                onClick={() => OnClose()}
              >
                Close
              </Button>
            </GridItem>
          </GridContainer>
          <GridContainer>
            {isOtpMode && (
              <>
                <GridItem xs={12} sm={12} md={4} lg={4}>

                <CustomeTextField
              label="OTP Code"
              required
              id="otp_code"
              value={otpValidation}
              setState={setOtpValidation}
            />
                </GridItem>
                <GridContainer>
                <GridItem xs={12} sm={12} md={2} lg={2} style={{ marginTop: 27 }}>
                  <Button
                    size="small"
                    // className="bg-gradient-theme-left border-0"
                    // color="info"
                    className={classes.nextButton}
                    disabled={callInProgress}
                    onClick={(event) => validatecode(event)}
                  >
                    Validate
                  </Button>
                </GridItem>
                <GridItem xs={12} sm={12} md={2} lg={2} style={{ marginTop: 27 }}>
                  <Button
                    size="small"
                    // className="bg-gradient-theme-left border-0"
                    // color="info"
                    className={classes.nextButton1}
                    onClick={(event) => resendcode(event)}

                  >
                    Resend Code
                  </Button>
                </GridItem>
                </GridContainer>
                {isErrorMode && (
                  <GridItem xs={2} sm={2} md={2} lg={2}>
                    <p> Please provide the correct OTP code</p>
                  </GridItem>
                )}
              </>
            )}
          </GridContainer>
        </GridItem>
        {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
        {showModal && (
          <OtpModal
            handleClose={handleClose}
            showModal={showModal}
            Otp={verifyOtp}
            ResendOtp={sendEMailOtp}
          />
        )}
        {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
        {confirmationModal && (
          <ConfirmationModal
            confirmationModal={confirmationModal}
            confirmationModalHeader={confirmationModalHeader}
            confirmationModalMsg={confirmationModalMsg}
            handleNegativeButton={handleNegativeResponse}
            handlePositiveButton={handlePositiveResponse}
            classes={classes}
          />
        )}
      </GridContainer>
      </Grid>
  );
};

InProcessCreateApplication.propTypes = {
  classes: PropTypes.object,
  GetData: PropTypes.func,
  closeModal: PropTypes.func,
};

export default InProcessCreateApplication;